import { render } from "./filter-section.vue?vue&type=template&id=96569a40&ts=true&lang=pug"
import script from "./filter-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./filter-section.vue?vue&type=script&setup=true&lang=ts"

import "./filter-section.vue?vue&type=style&index=0&id=96569a40&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__